import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import auth, { loadUserFromLocalStorage } from "src/store/slices/auth";
import { PrivateApi, PublicApi } from "./apis/BaseApi";

export const store = configureStore({
  reducer: {
    auth: auth,
    [PublicApi.reducerPath]: PublicApi.reducer,
    [PrivateApi.reducerPath]: PrivateApi.reducer,
  },
  preloadedState: {
    auth: loadUserFromLocalStorage(),
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      PublicApi.middleware,
      PrivateApi.middleware
    );
  },
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
